import { h } from 'preact';
import Image from '../utils/image';
import RichText from '../utils/richtext';
import IconCaret from '../utils/icon/caret-down.svg';

const SubscriptionCallout = ({ data, isLimited }) => {
  const currentData = isLimited ? data.limited : data.default

  return currentData && <div className='mt-3.5'>
    <details className='mb-7 mx-5 laptop:mx-0 bg-cream-grey pt-2.5 px-2.5 [&[open]>summary]:mb-2.5'>
      <summary className='list-none cursor-pointer pb-2.5 transition-all [&::-webkit-details-marker]:hidden'>
        <div className='flex gap-4 items-center'>
            <Image
              src={currentData.icon}
              classes={'object-contain hidden laptop:block w-5'}
              srcWidths={{ sm: 42 }}
              width={21}
              height={21}
            />
          <div className='flex-grow'>
            <h6 className='utility-2 mb-1 font-medium'>{ currentData.headerText }</h6>
            {currentData.subheaderText && <RichText customRootClass={'mb-0 utility-2'} data={currentData.subheaderText} />}
          </div>
          <span className='cursor-pointer'><IconCaret /></span>
        </div>
      </summary>
      <div className='border-t -mt-2.5 py-2.5 border-black/30'>
        {currentData.description && <RichText customRootClass={'mb-0 utility-2 text-charcoal'} data={currentData.description} />}
      </div>
    </details>
  </div>
}

export default SubscriptionCallout